export default "__VITE_ASSET__3XV1AJVy__"